import { gql } from "urql";
export const AssignPatientsToProviderMutation = gql `
    mutation AssignPatientsToProvider($input: PatientsToProviderInput!) {
        patientAssignments {
            linkProviderToPatients(input: $input) {
                providerId
                provider {
                    userId
                    numberOfPatients
                }
            }
        }
    }
`;
export const AssignProvidersToPatientMutation = gql `
    mutation AssignProvidersToPatient($input: ProvidersToPatientInput!) {
        patientAssignments {
            linkPatientToProviders(input: $input) {
                patientId
                priorityEntries {
                    priorityEntryId
                    providers {
                        userId
                        firstName
                        lastName
                        imageUrl
                    }
                }
            }
        }
    }
`;
